"use strict";

var _toConsumableArray = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bufferArrayUniqueItems = exports.bufferArrayOrderByLex = exports.bufferArraySubtract = exports.bufferArrayEqual = exports.bufferArrayContainsSome = exports.bufferArrayContains = exports.bufferArrayIncludes = void 0;

var buffer_set_1 = require("../data_structures/buffer_set");

var bufferArrayIncludes = function bufferArrayIncludes(arr, val) {
  return arr.find(function (a) {
    return a.equals(val);
  }) !== undefined;
};

exports.bufferArrayIncludes = bufferArrayIncludes;

var bufferArrayContains = function bufferArrayContains(arr1, arr2) {
  return arr2.every(function (val) {
    return exports.bufferArrayIncludes(arr1, val);
  });
};

exports.bufferArrayContains = bufferArrayContains;

var bufferArrayContainsSome = function bufferArrayContainsSome(arr1, arr2) {
  return arr2.some(function (val) {
    return exports.bufferArrayIncludes(arr1, val);
  });
};

exports.bufferArrayContainsSome = bufferArrayContainsSome;

var bufferArrayEqual = function bufferArrayEqual(arr1, arr2) {
  return arr1.length === arr2.length && arr1.every(function (val, index) {
    return val.equals(arr2[index]);
  });
};

exports.bufferArrayEqual = bufferArrayEqual;

var bufferArraySubtract = function bufferArraySubtract(arr1, arr2) {
  return arr1.filter(function (a) {
    return !exports.bufferArrayIncludes(arr2, a);
  });
};

exports.bufferArraySubtract = bufferArraySubtract;

var bufferArrayOrderByLex = function bufferArrayOrderByLex(arr1) {
  var sortedArray = _toConsumableArray(arr1);

  sortedArray.sort(function (a, b) {
    return a.compare(b);
  });
  return exports.bufferArrayEqual(arr1, sortedArray);
};

exports.bufferArrayOrderByLex = bufferArrayOrderByLex;

var bufferArrayUniqueItems = function bufferArrayUniqueItems(arr1) {
  return arr1.length === new buffer_set_1.BufferSet(_toConsumableArray(arr1)).size;
};

exports.bufferArrayUniqueItems = bufferArrayUniqueItems;